module.exports = __webpack_public_path__ + "static/media/attorney-review.136599c9.png";